import urls from "../urls"
import { callGetApi } from "../callApi"


const categoryService = {
    getcategories: () => {
        return callGetApi(urls.GET_CATEGORIES)
    },
}


export default categoryService